var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5L0.499998 35.5",
    stroke: "black",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_51)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7142 8.71695C36.9332 7.9359 35.6668 7.9359 34.8858 8.71695L33.6635 9.93921L38.5465 14.8222L39.7687 13.5999C40.5498 12.8189 40.5498 11.5525 39.7687 10.7715L37.7142 8.71695ZM37.1451 16.2235L32.2621 11.3406L22.4678 21.1349C22.2663 21.3364 22.1102 21.5786 22.0099 21.8454L20.7724 25.1375C20.1676 26.7462 21.7395 28.3181 23.3482 27.7133L26.6403 26.4757C26.9071 26.3755 27.1493 26.2194 27.3508 26.0179L37.1451 16.2235Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20.5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil2);
export default __webpack_public_path__ + "static/media/pencil2.385d4e89a7391e1777dbe37f116192de.svg";
export { ForwardRef as ReactComponent };